import { c as _c } from "react/compiler-runtime";
import { graphqlClient } from "@/lib/graphql-client";
import { useQuery } from "@tanstack/react-query";
import { graphql, ResultOf } from "@/graphql";
const PlansQuery = graphql(`
  query getPlans {
    plans {
      sku
      name
      price
      tier {
        id
        level
        name
      }
      billingInterval
      isCurrent
    }
  }
`);
export type PlansQueryResult = ResultOf<typeof PlansQuery>;
export type Plan = PlansQueryResult["plans"][number];
export function usePlansQuery() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["plans"],
      queryFn: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
function _temp2() {
  return graphqlClient.request(PlansQuery).then(_temp);
}
function _temp(res) {
  return res.plans;
}